import { getMediasBySector } from "@/services/accomodation"
import { getName } from "@/services/aroeven"
import { createObjectPagePathname, getMediaUrl } from "@/services/pathname"
import Link from "next/link"

type CardProps = {
    accomodation: Accomodation
}

export default function Card({
    accomodation
}: CardProps) {
    return (
        <>
            <Link href={createObjectPagePathname('SchoolStay', accomodation)} className="vignette -type-1 h-100">
                <div className="vignette__image">
                    <div className="cardImage ratio ratio-1:1">
                        <div className="cardImage__content">
                            <img className="col-12" src={getMediaUrl(getMediasBySector(accomodation, 'school').filter(media => media.mimeType.indexOf('image/') === 0)[0]?.url ?? '#')} alt="image" />
                        </div>
                    </div>
                    <div className="bandeau">
                        <i className="fi fi-rr-ruler-triangle" /> Séjour scolaire
                    </div>
                </div>
                <div className="vignette__content mt-10">
                    <div className="d-flex flex-column justify-content-between h-100">
                        <div>
                            <p className="text-light-1 lh-14 text-13 mt-5 mb-0">
                                <i className="fi fi-rr-marker text-primary-4" />
                                {accomodation.address.city} ({accomodation.address.postCode.slice(0, 2)})
                            </p>
                            <h4 className="vignette__title lh-16">
                                {accomodation.name}
                            </h4>
                            <ul className="equipements mb-10">
                                {accomodation.nationalEducationCapacity && <li>Capacité Education Nationale : {accomodation.nationalEducationCapacity}</li>}
                                {accomodation.numberOfClassrooms && <li>{accomodation.numberOfClassrooms} salle{accomodation.numberOfClassrooms > 1 ? 's' : ''} de classe</li>}
                            </ul>
                        </div>
                        <div className="d-flex flex-column justify-content-end">
                            <div className="organisation d-flex items-start">
                                <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                    <i className="fi fi-rr-home" />
                                </div>
                                <div className='lh-1 mb-5'>
                                    Organisé par {getName(accomodation.proposedBy)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}